module.exports = __webpack_public_path__ + "img/20190715154746QQ截图20190715014020.97e23beb.png";